import { render, staticRenderFns } from "./cusplierBankAction.vue?vue&type=template&id=c531b45a&scoped=true"
import script from "./cusplierBankAction.vue?vue&type=script&lang=js"
export * from "./cusplierBankAction.vue?vue&type=script&lang=js"
import style0 from "./cusplierBankAction.vue?vue&type=style&index=0&id=c531b45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c531b45a",
  null
  
)

export default component.exports